var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.show, expression: "show" }
      ],
      staticClass: "lite_popup lite_options"
    },
    [
      _c("div", { staticClass: "lite_popup_box" }, [
        _c("div", { staticClass: "lite_popup_title" }, [
          _c("span", [_vm._v(_vm._s(_vm.$t("language.common.options")))]),
          _vm._v(" "),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.close()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "lite_popup_content" },
          [
            _c(
              "el-tabs",
              {
                model: {
                  value: _vm.activeName,
                  callback: function($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName"
                }
              },
              [
                _vm.isVip()
                  ? _c(
                      "el-tab-pane",
                      {
                        attrs: {
                          label: _vm.$t("language.popup.thread"),
                          name: "thread"
                        }
                      },
                      [
                        _c("div", { staticClass: "lite_tab_content" }, [
                          _c(
                            "div",
                            { staticClass: "thread_item" },
                            [
                              _c("span", { staticClass: "thread_item_lable" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.popup.listThread")) +
                                    ": " +
                                    _vm._s(_vm.options.listThread)
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-slider", {
                                staticClass: "my-slider",
                                attrs: {
                                  "show-tooltip": false,
                                  step: 1,
                                  min: 1,
                                  max: 5,
                                  "show-stops": ""
                                },
                                model: {
                                  value: _vm.options.listThread,
                                  callback: function($$v) {
                                    _vm.$set(_vm.options, "listThread", $$v)
                                  },
                                  expression: "options.listThread"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "thread_item" },
                            [
                              _c("span", { staticClass: "thread_item_lable" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("language.popup.runThread")) +
                                    ": " +
                                    _vm._s(_vm.options.runThread)
                                )
                              ]),
                              _vm._v(" "),
                              _c("el-slider", {
                                staticClass: "my-slider",
                                attrs: {
                                  "show-tooltip": false,
                                  step: 1,
                                  min: 1,
                                  max: 15,
                                  "show-stops": ""
                                },
                                model: {
                                  value: _vm.options.runThread,
                                  callback: function($$v) {
                                    _vm.$set(_vm.options, "runThread", $$v)
                                  },
                                  expression: "options.runThread"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-tab-pane",
                  {
                    attrs: {
                      label: _vm.$t("language.popup.email"),
                      name: "email"
                    }
                  },
                  [
                    _c("div", { staticClass: "lite_tab_content" }, [
                      _c(
                        "div",
                        { staticClass: "email_desc" },
                        [
                          _c(
                            "el-checkbox",
                            {
                              model: {
                                value: _vm.enableEmail,
                                callback: function($$v) {
                                  _vm.enableEmail = $$v
                                },
                                expression: "enableEmail"
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("language.popup.sendEmail")))]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "email_box" },
                        [
                          _c("div", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.enableEmail,
                                expression: "!enableEmail"
                              }
                            ],
                            staticClass: "email_mark"
                          }),
                          _vm._v(" "),
                          _c("el-input", {
                            staticClass: "email_input",
                            attrs: { size: "small", placeholder: "Email" },
                            on: { focus: _vm.onEmailFocus },
                            model: {
                              value: _vm.options.email,
                              callback: function($$v) {
                                _vm.$set(_vm.options, "email", $$v)
                              },
                              expression: "options.email"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "email_test",
                              on: {
                                click: function($event) {
                                  return _vm.sendEmail()
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("language.popup.sendMessage"))
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c("el-tab-pane", { attrs: { name: "filter" } }, [
                  _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("language.popup.filter")))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "lite_vip_icon" })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "lite_tab_content" }, [
                    _c("div", { staticClass: "tag_desc" }, [
                      _vm._v(_vm._s(_vm.$t("language.popup.filterInclude")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tag_box myscroll" },
                      [
                        _vm._l(_vm.options.allowedExtensions, function(tag) {
                          return _c(
                            "el-tag",
                            {
                              key: tag,
                              attrs: {
                                closable: "",
                                "disable-transitions": false,
                                color: "#5562b430",
                                effect: "plain",
                                type: "info"
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleCloseIncluded(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(tag) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.inputVisibleIncluded
                          ? _c("el-input", {
                              ref: "saveTagInput",
                              staticClass: "input-new-tag",
                              attrs: { size: "small" },
                              on: { blur: _vm.handleInputConfirmIncluded },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleInputConfirmIncluded($event)
                                }
                              },
                              model: {
                                value: _vm.inputValueIncluded,
                                callback: function($$v) {
                                  _vm.inputValueIncluded = $$v
                                },
                                expression: "inputValueIncluded"
                              }
                            })
                          : _c(
                              "button",
                              {
                                staticClass: "button-new-tag",
                                attrs: { size: "small" },
                                on: { click: _vm.showInputIncluded }
                              },
                              [
                                _vm._v(
                                  "+ " +
                                    _vm._s(
                                      _vm.$t("language.popup.newFilterTag")
                                    )
                                )
                              ]
                            )
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "tag_desc" }, [
                      _vm._v(_vm._s(_vm.$t("language.popup.filterExclude")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tag_box myscroll" },
                      [
                        _vm._l(_vm.options.excludeNames, function(tag) {
                          return _c(
                            "el-tag",
                            {
                              key: tag,
                              attrs: {
                                closable: "",
                                "disable-transitions": false,
                                color: "#5562b430",
                                effect: "plain",
                                type: "info"
                              },
                              on: {
                                close: function($event) {
                                  return _vm.handleCloseExclude(tag)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(tag) +
                                  "\n                            "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.inputVisibleExclude
                          ? _c("el-input", {
                              ref: "saveTagInput",
                              staticClass: "input-new-tag",
                              attrs: { size: "small" },
                              on: { blur: _vm.handleInputConfirmExclude },
                              nativeOn: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.handleInputConfirmExclude($event)
                                }
                              },
                              model: {
                                value: _vm.inputValueExclude,
                                callback: function($$v) {
                                  _vm.inputValueExclude = $$v
                                },
                                expression: "inputValueExclude"
                              }
                            })
                          : _c(
                              "button",
                              {
                                staticClass: "button-new-tag",
                                attrs: { size: "small" },
                                on: { click: _vm.showInputExclude }
                              },
                              [
                                _vm._v(
                                  "+ " +
                                    _vm._s(
                                      _vm.$t("language.popup.newFilterTag")
                                    )
                                )
                              ]
                            )
                      ],
                      2
                    )
                  ])
                ]),
                _vm._v(" "),
                false
                  ? _c("el-tab-pane", { attrs: { name: "schedule" } }, [
                      _c("span", { attrs: { slot: "label" }, slot: "label" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "language.popup.cloudTransferPopup.schedule"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "lite_vip_icon" })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "lite_tab_content" }, [
                        _vm.showCronHelp
                          ? _c("div", { staticClass: "cron_desc myscroll" }, [
                              _c("strong", [_vm._v("Cron Expression Help:")]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "A cron expression consists of 6 fields: second, minute, hour, day, month, and weekday, separated by spaces."
                                )
                              ]),
                              _vm._v(" "),
                              _c("ul", [
                                _c("li", [
                                  _c("strong", [_vm._v("Second:")]),
                                  _vm._v(" 0-59")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Minute:")]),
                                  _vm._v(" 0-59")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Hour:")]),
                                  _vm._v(" 0-23")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Day:")]),
                                  _vm._v(" 1-31")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Month:")]),
                                  _vm._v(" 1-12 or JAN-DEC")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c("strong", [_vm._v("Weekday:")]),
                                  _vm._v(
                                    " 0-7 or SUN-SAT (0 and 7 both mean Sunday)"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [_vm._v("Special characters:")])
                              ]),
                              _vm._v(" "),
                              _c("ul", [
                                _c("li", [_vm._v("* Any value")]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "/ Step, e.g., 0/5 means every 5 units"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [_vm._v(", List, e.g., MON,WED,FRI")]),
                                _vm._v(" "),
                                _c("li", [_vm._v("- Range, e.g., 10-15")]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v("? Placeholder (no specific value)")
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "L Last, e.g., day field L means the last day of the month"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "W Nearest weekday, e.g., 15W means the weekday nearest the 15th"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "# Nth weekday, e.g., 3#2 means the 2nd Wednesday of the month"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [_vm._v("Common examples:")])
                              ]),
                              _vm._v(" "),
                              _c("ul", [
                                _c("li", [
                                  _vm._v(
                                    "0 * * * * * → triggers at 0 second every minute"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "0 0/5 * * * * → triggers every 5 minutes"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "0 0 9 * * * → triggers every day at 9:00 AM"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "0 0 0 1 * * → triggers at 00:00 on the 1st day of every month"
                                  )
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _vm._v(
                                    "0 0 12 * * MON-FRI → triggers at 12:00 PM Monday through Friday"
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _c("strong", [_vm._v("Tips:")]),
                                _vm._v(
                                  " Do not set intervals shorter than 5 minutes. Cron execution respects the user's timezone. You can also validate cron expressions and check their next execution times in real-time."
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("el-input", {
                              staticClass: "cron_input",
                              attrs: {
                                size: "small",
                                placeholder: "cron expression"
                              },
                              model: {
                                value: _vm.options.cron,
                                callback: function($$v) {
                                  _vm.$set(_vm.options, "cron", $$v)
                                },
                                expression: "options.cron"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "el-select",
                              {
                                staticClass: "cron_select",
                                attrs: {
                                  size: "small",
                                  placeholder: "Please select"
                                },
                                model: {
                                  value: _vm.options.cron,
                                  callback: function($$v) {
                                    _vm.$set(_vm.options, "cron", $$v)
                                  },
                                  expression: "options.cron"
                                }
                              },
                              _vm._l(_vm.cronDemo, function(item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: { label: item.name, value: item.value }
                                })
                              }),
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "cron_help",
                                on: {
                                  click: function($event) {
                                    _vm.showCronHelp = !_vm.showCronHelp
                                  }
                                }
                              },
                              [_vm._v("Help")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "cron_result" }, [
                          _vm.cronNextExec.length > 0
                            ? _c("div", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "cron_decode",
                                    attrs: {
                                      title: _vm.cron2Str(_vm.options.cron)
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Expected execution time for the next 5 times: "
                                    ),
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.cron2Str(_vm.options.cron))
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "ol",
                                  _vm._l(_vm.cronNextExec, function(time) {
                                    return _c("li", [
                                      _vm._v(_vm._s(_vm.formatDate(time)))
                                    ])
                                  }),
                                  0
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ])
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "lite_popup_footer" }, [
          _c(
            "button",
            {
              staticClass: "white",
              on: {
                click: function($event) {
                  return _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              on: {
                click: function($event) {
                  return _vm.ok()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("language.common.save")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e72f6452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e72f6452","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/workspace/lite_options.vue
// module id = null
// module chunks = 